import { request } from './request';

export const submitFeedback = (email, feedback) => {
  return request('/feedback/submit-feedback', 'POST', { email, feedback });
};
